import { render, staticRenderFns } from "./FaviconForm.vue?vue&type=template&id=7b0a80b9"
import script from "./FaviconForm.vue?vue&type=script&lang=js"
export * from "./FaviconForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports